export const RECAPTCHA_SITE_KEY = '6LfQ5ZcUAAAAAMwcrr_Lc1649v318RvZ4ixRdgqm';
